var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("van-sticky", [
    _c(
      "div",
      { staticClass: "title-bar" },
      [
        _vm._t("left-content"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "project-list" },
          [
            _c(
              "van-dropdown-menu",
              { attrs: { "title-class": "titleClass" } },
              [
                _c("van-dropdown-item", {
                  attrs: { options: _vm.projectList },
                  on: { change: _vm.changeSelectProject },
                  model: {
                    value: _vm.currentProjectId,
                    callback: function($$v) {
                      _vm.currentProjectId = $$v
                    },
                    expression: "currentProjectId"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [_vm._t("content")], 2)
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right-content", on: { click: _vm.handleClick } },
          [_vm._t("default")],
          2
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d371f8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d371f8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TitleBar/index.vue
// module id = null
// module chunks = 